import React from "react";
import ReactModal from "react-modal";
import Select from "react-select";
import { updateUwData } from "../../../api/index";
import "./index.scss";

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        borderBottom: "1px solid #EAEBEF",
        padding: 10,
        fontSize: 14,
    }),
    control: (provided) => ({
        ...provided,
    }),
    menu: (provided) => ({
        ...provided,
    }),
};

class UwModal extends React.Component {
    constructor(props) {
        super(props);

        let uwListCopy = [...(this.props.uwData || [])];
        uwListCopy.unshift({ value: "", label: "Select UW" });

        this.state = {
            selectedOption: null,
            uwList: uwListCopy,
            menuCLose: true,
            show_spinner: false,
            error: "",
            appData: props.appData,
        };
    }

    handleSelectChange = (selectedOption) => {
        this.setState({ selectedOption: selectedOption });
    };

    submitApp = () => {
        let data = {
            app_id: this.state?.appData?.id,
            uw_id: this.state.selectedOption?.value,
        };
        updateUwData(data).then((res) => {
            if (res.status) {
                this.props.onClose(false);
                this.props.getAppData();
                this.setState({
                    error: "",
                });
            } else {
                this.setState({
                    error: res.message,
                });
            }
        });
    };

    render() {
        const { selectedOption, menuCLose, uwList } = this.state;

        return (
            <ReactModal isOpen={this.props.isOpen} className="edit-uw">
                <Select
                    styles={customStyles}
                    className={
                        menuCLose ? "uw-filter uwmodalselect" : "active-uw"
                    }
                    options={uwList}
                    onChange={this.handleSelectChange}
                    value={selectedOption}
                    placeholder="Select UW"
                    onMenuClose={(e) => this.setState({ menuCLose: true })}
                    onMenuOpen={(e) => this.setState({ menuCLose: false })}
                />
                <p className="text-danger">{this.state.error}</p>
                <div className="modal-footer">
                    <button
                        className="btn cancel-button"
                        onClick={() => this.props.onClose(false)}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn confirm-button"
                        onClick={() => this.submitApp()}
                    >
                        Update
                    </button>
                </div>
            </ReactModal>
        );
    }
}

export default UwModal;
